import { render, staticRenderFns } from "./HazmatInformationMessage.vue?vue&type=template&id=75f7101a&scoped=true"
import script from "./HazmatInformationMessage.vue?vue&type=script&lang=js"
export * from "./HazmatInformationMessage.vue?vue&type=script&lang=js"
import style0 from "./HazmatInformationMessage.vue?vue&type=style&index=0&id=75f7101a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f7101a",
  null
  
)

export default component.exports